import { Theme } from '@mui/material/styles';
import { SelectArrow } from '@/theme/overrides/CustomIcons';
import React from 'react';

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: (_props: any) => {
          const rotate = _props.className.toString().includes('iconOpen');
          const disabled = _props.className.toString().includes('Mui-disabled');
          return (
            <SelectArrow
              style={{
                position: 'absolute',
                top: 'calc(50% - 10px)',
                right: 16,
                height: '20px',
                width: '20px',
                transform: rotate ? 'rotate(180deg)' : 'none',
                pointerEvents: 'none',
                cursor: 'pointer',
              }}
              stroke={disabled ? '#D1D8E2' : 'black'}
              className={_props.className}
            />
          );
        },
      },

      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            background: 'var(--dk-bg-subtle, #F9FAFB)',
            borderColor: 'var(--dk-line, #E7E9EC)',
            color: 'var(--dk-text-disabled, #D1D8E2)',
          },
        },
      },
    },
  };
}
